function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { presets as CubicBezier, animate } from '@bydesign-ui/utils';
import { useRef } from 'react';
export function useSecondChildExpandAnimation(elementRef, options) {
  var initRef = useRef(false);
  var disabled = options.disabled,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 400 : _options$duration,
      expanded = options.expanded,
      _options$ignoreInitia = options.ignoreInitialRender,
      ignoreInitialRender = _options$ignoreInitia === void 0 ? true : _options$ignoreInitia;
  return function () {
    if (ignoreInitialRender && !initRef.current || disabled) {
      initRef.current = true;
      return;
    }

    var tick = function tick(percent) {
      handleAnimationTick(elementRef.current, tick, percent, expanded);
    };

    tick.bodyHeight = 0;
    tick.headHeight = 0;

    var _animate = animate('linear', duration, tick),
        _animate2 = _slicedToArray(_animate, 2),
        start = _animate2[0],
        stop = _animate2[1];

    start();
    return function () {
      tick(1);
      stop();
    };
  };
}

function handleAnimationTick(element, memo, percent, expanded) {
  if (!element) {
    return;
  }

  if (!memo.headHeight || !memo.bodyHeight) {
    if (!element.firstElementChild || !element.lastElementChild) {
      return;
    }

    memo.headHeight = element.firstElementChild.getBoundingClientRect().height;
    memo.bodyHeight = element.childNodes.length === 1 ? 0 : element.lastElementChild.getBoundingClientRect().height;
  }

  if (expanded) {
    if (percent >= 0.5) {
      element.style.removeProperty('height');
    } else {
      percent = CubicBezier.easeOut(percent * 2);
      element.style.setProperty('height', "".concat(percent * memo.bodyHeight + memo.headHeight, "px"));
    }
  } else {
    if (percent >= 1) {
      element.style.removeProperty('height');
    } else if (percent >= 0.5) {
      percent = CubicBezier.easeIn((1 - percent) * 2);
      element.style.setProperty('height', "".concat(percent * memo.bodyHeight + memo.headHeight, "px"));
    } else if (element.style.getPropertyValue('height') !== "".concat(memo.bodyHeight + memo.headHeight, "px")) {
      element.style.setProperty('height', "".concat(memo.bodyHeight + memo.headHeight, "px"));
    }
  }
}